import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "participant" }
const _hoisted_2 = { class: "participantName" }

import { useComputedValue } from "@/composables";
import { RoomParticipant } from "@/types/call";
import CallAvatar from "../CallAvatar/CallAvatar.vue";
import { ProfileAvatarSizeEnum } from "@/types/avatar";
import { GetterTypes } from "@/store";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import MediaDisplayControl from "../MediaOutputControl/MediaDisplayControl.vue";
interface Props {
  roomParticipant: RoomParticipant | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CallParticipant',
  props: {
    roomParticipant: {}
  },
  setup(__props: any) {

const props = __props;

const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const { t } = useI18n();

const participantText = computed(() => {
  let text = props.roomParticipant?.user.name;
  if (props.roomParticipant?.user.id === authId.value) {
    text += ` (${t("call.you")})`;
  }
  return text;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CallAvatar, {
      size: _unref(ProfileAvatarSizeEnum).Large,
      src: _ctx.roomParticipant?.user.picture,
      "is-connected": !!props.roomParticipant?.isConnected
    }, null, 8, ["size", "src", "is-connected"]),
    (_ctx.roomParticipant?.participant?.identity)
      ? (_openBlock(), _createBlock(MediaDisplayControl, {
          key: _ctx.roomParticipant?.participant?.identity,
          "room-participant": _ctx.roomParticipant,
          class: "participantRef"
        }, null, 8, ["room-participant"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, _toDisplayString(participantText.value), 1)
  ]))
}
}

})